import React, { PropsWithChildren, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { IPlainObject } from '../../models';
import { BreadcrumbsComponent } from '../../components/breadcrumbs-component';
import { selectBreadcrumbsAliases } from '../../store/reducers';

export function BreadcrumbsLayout({
  children,
}: PropsWithChildren<IPlainObject>): ReactElement {
  const breadcrumbsAliases = useSelector(selectBreadcrumbsAliases());

  return (
    <div>
      <BreadcrumbsComponent breadcrumbsAliases={breadcrumbsAliases} />
      {children}
    </div>
  );
}
